import styled, { css } from 'styled-components';
import type { Localization } from '../../../../../../common/Localization';

export const ListViewSortItemContainer = styled.button<{
  isSelected?: boolean;
  optionsLength?: number;
  localization?: Localization;
  isLoading?: boolean;
}>`
  ${({ theme }) => theme.kallisto.mixins.font('Title6')};
  padding: 0 16px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  text-align: center;
  height: 100%;
  cursor: pointer;
  transition: 0.2s ease-out;
  background: transparent;
  border-right: 1px solid ${({ theme }) => theme.kallisto.color.border.static.borderNeutral};

  &:first-child {
    overflow: hidden;
    border-radius: 8px 0 0 8px;
  }

  &:hover {
    box-shadow: inset 0 -4px 0 0 ${({ theme }) => theme.kallisto.color.text.interactive.textPrimaryDefault};
  }

  ${({ isLoading }) =>
    isLoading &&
    css`
      color: ${({ theme }) => theme.kallisto.color.common.black[200]};
      cursor: default;
      user-select: none;

      &:hover {
        box-shadow: unset;
      }
    `};

  ${({ isSelected }) =>
    isSelected &&
    css`
      color: ${({ theme }) => theme.kallisto.color.text.interactive.textPrimaryDefault};
      box-shadow: inset 0 -4px 0 0 ${({ theme }) => theme.kallisto.color.text.interactive.textPrimaryDefault};
    `};

  ${({ isSelected, isLoading }) =>
    isSelected &&
    isLoading &&
    css`
      color: ${({ theme }) => theme.kallisto.color.common.black[200]};
      box-shadow: inset 0 -4px 0 0 ${({ theme }) => theme.kallisto.color.common.black[200]};

      &:hover {
        box-shadow: inset 0 -4px 0 0 ${({ theme }) => theme.kallisto.color.common.black[200]};
      }
    `};

  ${({ optionsLength }) =>
    optionsLength && optionsLength > 6
      ? css`
          width: calc((100% - 56px) / 4);
        `
      : css`
          width: calc(100% / 4);
        `};

  /* A gap, not an icon margin: the icon's own margin holds its footprint. */
  gap: 8px;

  > span {
    height: 16px;
    display: block;
  }
`;
